module.exports = __webpack_public_path__ + "static/media/leading-wellbeing-large.b1096381.png";